import { OverlayWithBlur } from 'components/overlays/OverlayWithBlur';

import { PreparedWorkload } from 'features/workload-optimization';
import { HpaOverrideSettingsRow } from './HpaOverrideSettingsRow';

import { HpaSettingRow } from './HpaSettingRow';
import { HpaSettingsContent } from './HpaSettingsContent';
import { NextHpaSettingsButton } from '../../../../../_woop-settings/_components/layout/NextHpaSettingsButton';
import { SettingsLayout } from '../../../../../_woop-settings/_components/layout/SettingsLayout';
import {
  HpaSelectedSettingNameProvider,
  useHpaSelectedSettingName,
} from '../../../../../_woop-settings/hpaSelectedSettingNameContexts';
import { RightsizingHpaSettingsBanners } from '../../../../_components/RightsizingHpaSettingsBanners';
import { useIsHpaSettingsMissingOnWorkloadForm } from '../../../../_hooks/useIsHpaSettingsMissingOnWorkloadForm';
import { ExplanationTooltip } from '../../ExplanationTooltip';
import { OverrideGroupProvider } from '../../override/OverrideGroupProvider';
import {
  WorkloadHpaFormSettings,
  workloadHpaFormSettings,
} from '../_constants';
import { useHpaSettingIsDefault } from '../_hooks/useHpaSettingIsDefault';
import { Box, Stack } from '@cast/design-system';

const HpaSettingsRows = () => {
  const { settingsList } = useHpaSelectedSettingName<WorkloadHpaFormSettings>();

  return (
    <>
      {settingsList.map((name) => (
        <HpaSettingRow key={name} name={name} />
      ))}
    </>
  );
};

export const HpaSettingsV2Form = ({
  workload,
}: {
  workload: PreparedWorkload;
}) => {
  const { isHpaSettingsMissingOnWorkloadForm } =
    useIsHpaSettingsMissingOnWorkloadForm();
  const hpaSettings = !!workload?.verticalScalingPolicy?.hpaSettings;

  return (
    <Stack data-testid="horizontal-rightsizing-settings-v2">
      <RightsizingHpaSettingsBanners sx={{ mb: 24 }} />

      <HpaSelectedSettingNameProvider
        defaultName="basicBehavior"
        useSettingIsDefault={useHpaSettingIsDefault}
        settingsList={workloadHpaFormSettings}
      >
        <OverlayWithBlur
          active={isHpaSettingsMissingOnWorkloadForm}
          testId="hpa-settings-blur-overlay"
        >
          <OverrideGroupProvider name="horizontalRightsizing" canOverride>
            <SettingsLayout
              headerSection={hpaSettings && <HpaOverrideSettingsRow />}
              settingsRows={<HpaSettingsRows />}
              settingsContent={
                <ExplanationTooltip skipAnnotationsTooltip followCursor>
                  <Box>
                    <HpaSettingsContent />
                  </Box>
                </ExplanationTooltip>
              }
              nextButton={<NextHpaSettingsButton />}
            />
          </OverrideGroupProvider>
        </OverlayWithBlur>
      </HpaSelectedSettingNameProvider>
    </Stack>
  );
};
